export const IDEAS_UPLOADER_ID = 'ideas'
export const IDEA_EDITOR_ID = 'idea-editor'
